import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  flyerRemovedPage: css`
    display: flex;
    flex-flow: column nowrap;
    min-height: 100vh;
  `,
  header: css`
    display: flex;
    z-index: 1199;
    position: sticky;
    transition: top 0.2s ease-out;
    background: ${colors.white};
    svg {
      color: ${colors.prussian};
    }
  `,
  flyerRemovedContainer: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  `,
  flyerRemovedButton: css`
    padding-top: 37px;
    z-index: 9999999;
  `,
   flyerRemovedBottom: css`
     z-index: 9999999;
  `,
};

export default styles;
